import { SVGProps, Ref, forwardRef } from 'react';

export const ClipOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.216 3.782a3.343 3.343 0 0 0-4.727 0l-8.093 8.093a5.464 5.464 0 1 0 7.728 7.727l7.603-7.604L22 13.271l-7.604 7.604A7.264 7.264 0 1 1 4.124 10.602l8.092-8.092a5.143 5.143 0 0 1 7.273 7.272l-8.094 8.095a3.021 3.021 0 0 1-4.273-4.273l7.214-7.215 1.273 1.273-7.214 7.215a1.221 1.221 0 1 0 1.727 1.727l8.094-8.094a3.343 3.343 0 0 0 0-4.728"
                fill="currentColor"
            />
        </g>
    </svg>
));
ClipOutlinedSize24Glyph.displayName = 'ClipOutlinedSize24Glyph';
